import {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardRouter} from './internal/DashboardRouter'
import ManagementsRouter from './internal/ManagementRouter'
import FinancialRouter from './internal/FinancialRouter'

export function PrivateRoutes() {
    const ProfilePage = lazy(() => import('../pages/profile'))
    const ShowPdv = lazy(() => import('../pages/pdvs/ShowPdv'))

    return (
        <Suspense fallback={<FallbackView />}>
            <Switch>
                <Route path='/meu-perfil' component={ProfilePage} />
                <Route path='/pdv' component={ShowPdv} />

                <Route path='/painel' component={DashboardRouter} />
                <Route path='/gestao' component={ManagementsRouter} />
                <Route path='/financeiro' component={FinancialRouter} />

                <Redirect from='/autenticacao' to='/painel/administrativo' />
                <Redirect exact from='/' to='/painel/administrativo' />
                <Redirect to='error/404' />
            </Switch>
        </Suspense>
    )
}
